import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import { keycloak } from "..";
import {
  AUTH_LOCALSTORAGE_NAME,
  HOLIDAY_PRODUCT_ID,
  IMPORT_GLOBAL_API_KEY,
  HOLIDAY_MANAGE_API,
} from "../constants/constants";

export const holidayServiceApi = createApi({
  reducerPath: "holidayEmployeeApi",
  baseQuery: async (args, api, extraOptions) => {
    const baseQuery = fetchBaseQuery({
      baseUrl: HOLIDAY_MANAGE_API,
      prepareHeaders: async (headers, { getState }) => {
        const authState = (getState() as any)?.auth;
        const authStoreToken = authState?.access_token;
        let token =
          typeof authStoreToken === "string"
            ? authStoreToken
            : authStoreToken?.access_token || authStoreToken?.token;

        if (!token) {
          const savedAuth = localStorage.getItem(AUTH_LOCALSTORAGE_NAME);
          if (savedAuth) {
            try {
              const parsedAuth = JSON.parse(savedAuth);
              token =
                parsedAuth?.access_token ||
                parsedAuth?.token ||
                parsedAuth?.user?.data?.token;
            } catch (error) {
              token = undefined;
            }
          }
        }

        if (typeof token === "string" && token.startsWith("Bearer ")) {
          token = token.replace(/^Bearer\s+/i, "");
        }
        if (!token && keycloak?.token) {
          token = keycloak.token;
        }

        const pickProductIdFromToken = (jwtToken?: string): string | undefined => {
          if (!jwtToken) return undefined;
          try {
            const tokenValue = jwtToken.replace(/^Bearer\s+/i, "");
            const parts = tokenValue.split(".");
            if (parts.length < 2) return undefined;
            const normalizedPayload = parts[1]
              .replace(/-/g, "+")
              .replace(/_/g, "/")
              .padEnd(Math.ceil(parts[1].length / 4) * 4, "=");
            const payload = JSON.parse(atob(normalizedPayload));

            const candidates: Array<any> = [
              payload?.productid,
              payload?.productId,
              payload?.product_id,
              payload?.userProject?.id,
              payload?.userProject?.productid,
              payload?.userProject?.productId,
              payload?.userProject?.product_id,
              payload?.user_project?.id,
              payload?.userProjects?.[0]?.id,
              payload?.user_projects?.[0]?.id,
              payload?.projects?.[0]?.id,
            ];
            const picked = candidates.find((item) => item !== undefined && item !== null && String(item).trim());
            return picked ? String(picked).trim() : undefined;
          } catch (error) {
            return undefined;
          }
        };
        //

        const productId =
          localStorage.getItem("product_id") ||
          pickProductIdFromToken(token) ||
          HOLIDAY_PRODUCT_ID;
        const importApiKey =
          IMPORT_GLOBAL_API_KEY ||
          localStorage.getItem("import_global_api_key");

        if (token) {
          headers.set("Authorization", `Bearer ${token}`);
        }
        if (productId) {
          headers.set("productid", productId);
          headers.set("productId", productId);
          headers.set("x-productid", productId);
        }
        if (importApiKey) {
          headers.set("x-import-key", importApiKey);
        }

        headers.set("ngrok-skip-browser-warning", "true");

        return headers;
      },
    });

    const result = await baseQuery(args, api, extraOptions);

    return result;
  },

  endpoints: () => ({}),
  tagTypes: ["GetHolidays", "GetHolidaysByDate", "GetHolidayDetails"],
});
